export enum LoginFlow {
    SIGN_IN = "signIn",
    SIGN_UP = "signUp"
}